import { formatMoney } from '../../../utils/utils';
import {
  formatOptionalMoneyOrNone,
  parsePaymentAmount
} from '../../properties/Unit&Amenities/Amenities/V2/amenityPaymentConfigV2';

function hasStoredAmount(value) {
  const amount = parsePaymentAmount(value);
  return amount != null && amount > 0;
}

export function resolveBookingSubtotal(breakdown, paymentDetails) {
  if (hasStoredAmount(breakdown?.subtotal)) {
    return parsePaymentAmount(breakdown.subtotal);
  }
  if (hasStoredAmount(paymentDetails?.subtotal)) {
    return parsePaymentAmount(paymentDetails.subtotal);
  }

  return parsePaymentAmount(breakdown?.total_without_processing_fee) ?? 0;
}

export function formatBookingCostBreakdownDisplay(breakdown, t, paymentDetails) {
  const cost = parsePaymentAmount(breakdown?.cost);
  const deposit = parsePaymentAmount(breakdown?.deposit);
  const total = parsePaymentAmount(breakdown?.total);
  const subtotal = resolveBookingSubtotal(breakdown, paymentDetails);

  return {
    bookingFee: cost != null && cost > 0 ? formatMoney(cost) : '—',
    bookingFeeTooltip: t('booking_booking_fee_tooltip', {
      defaultValue: 'Cost of the amenity booking, based on a flat rate or booking duration.'
    }),
    serviceFee: formatOptionalMoneyOrNone(breakdown?.service_charge, t),
    serviceFeeTooltip: t('booking_service_fee_tooltip', {
      defaultValue: 'One-time fee per booking for additional services'
    }),
    deposit:
      deposit != null && deposit > 0
        ? `${formatMoney(deposit)} · ${t('Refundable', { defaultValue: 'Refundable' })}`
        : formatOptionalMoneyOrNone(deposit, t),
    subtotal: subtotal != null ? formatMoney(subtotal) : '—',
    processingFee: formatOptionalMoneyOrNone(breakdown?.processing_fee, t),
    total: total != null ? formatMoney(total) : '—'
  };
}
